// angular imports
import { WritableSignal, signal } from "@angular/core";

// local imports
import { IBreadcrumbItemModel, ListItemFactory } from "@app/shared";
import { RoomContentDto } from "@app/catalog";


export class RoomGroupModel implements IBreadcrumbItemModel {
  public id: string = "";
  public name: WritableSignal<string>;
  public thumbnailUrl: WritableSignal<string>;
  public isChecked: WritableSignal<boolean>;

  constructor() {
    this.name = signal<string>(null);
    this.thumbnailUrl = signal<string>(null);
    this.isChecked = signal<boolean>(false);
  }

  public handleImageError() {
    this.thumbnailUrl.set(`/assets/images/1.png`);
  }

  public select(val: boolean) {
    this.isChecked.set(val ? true : false);
  }

  public static fromDto(dto: RoomContentDto) {
    let room = new RoomGroupModel();

    room.id = dto.id;
    room.thumbnailUrl.set(dto.thumbnailUrl);
    room.name.set(dto.name);

    return room;
  }

  public toListItem = (selected: boolean = false) => 
      ListItemFactory.create<RoomGroupModel>(this.name, this.id, this, selected);
  

  public toListItem$ = (selected: WritableSignal<boolean>) =>
      ListItemFactory.create$<RoomGroupModel>(this.name, this.id, this, selected);  
}
